import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

export const useOfficesHolidaysTab = () => {
    const { getDataAsync } = useApi();

    const getAgenciesApiCall = useCallback(async () => {
        const response = await getDataAsync("holidaysTabActiveOffices");

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync]);

    const activeOffices = useQuery("activeOfficesList", getAgenciesApiCall, {
        staleTime: Infinity,
        cacheTime: 30 * 60 * 1000,
    });

    return useMemo(() => {
        return {
            activeOffices,
        };
    }, [activeOffices]);
};

const useTSHolidays = () => {
    const { getDataAsync } = useApi();

    const getHolidaysTabApiCall = useCallback(
        async ({ officeId, year }) => {
            const response = await getDataAsync("holidaysTab", {
                urlParams: [
                    { name: "$officeId", value: officeId },
                    {
                        name: "$year",
                        value: year,
                    },
                ],
            });

            const result = response.status === 204
                ? null
                : response.json();

            return result;

        },
        [getDataAsync]
    );

    return useMemo(() => {
        const useHolidaysTab = (dataObj) =>
            useQuery(["timesheetHolidays", dataObj], () =>
                getHolidaysTabApiCall(dataObj),
                {
                    staleTime: Infinity,
                    cacheTime: 30 * 60 * 1000,
                }
            );

        return {
            useHolidaysTab,
        };
    }, [getHolidaysTabApiCall]);
};

export default useTSHolidays;
